import { render } from "./blogdetail.vue?vue&type=template&id=f5b210be&scoped=true"
import script from "./blogdetail.vue?vue&type=script&lang=js"
export * from "./blogdetail.vue?vue&type=script&lang=js"

import "./blogdetail.vue?vue&type=style&index=0&id=f5b210be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b210be"]])

export default __exports__